
import React, { useCallback, useEffect, useRef, useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import Navigation from "../Navigation/Navigation";
import { format } from "date-fns";
import { Col, Form, Image, InputGroup, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cropper from "react-easy-crop";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import { toast } from "react-toastify";
import Datepickericon from "../../assets/date-picker.svg";
import defaultupload_fb from "../../assets/default-fb.png";
import defaultupload from "../../assets/default-upload.svg";
import SuccessImage from "../../assets/t-successfull.png";
import Modals from "../../Components/CreateVoucherCouponModal/CreateVoucherCouponModal";
import ProductModal from "../../Components/CreateVoucherCouponModal/ProductModal";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { FroalaTextEditor } from "../../Components/FroalaEditor/FroalaTextEditor";
import { stripHTML } from "../../Components/FroalaEditor/StripHtml";
import Loader from "../../Components/Loader/Loader";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { CouponCheckApi } from "../../Utils/Api/CouponCheckApi";
import { CreateCouponApi } from "../../Utils/Api/CreateCouponApi";
import { ManageCouponsApi } from "../../Utils/Api/ManageCoupons";
import { constant } from "../../Utils/Constant";
import { ErrorMessage } from "../../Utils/ErrorMsg/ErrorMsg";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { getUser, userId } from "../../Utils/LocalStorage";
import { resizeImage } from "../../Utils/ResizeUploadImg";
import getCroppedImg from "./cropImage";

const CloneCoupon = () => {
  const max_character_count = 1000;
  const parameter = useParams();
  const id = parseInt(parameter.id);
  const flag = parameter.flag;
  const flagValue = flag ? true : false;
  const f = flag ? true : false;
  const [imageSrc, setImageSrc] = useState("");
  const [inputtnc, setInputtnc] = useState();
  const [addtnc, setAddtnc] = useState([]);
  const [apitnc, setApiTnc] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [dat, setDat] = useState([]);
  const [data, setData] = useState([]);
  const [checkedItems, setCheckedItems] = useState();
  const [isbaseImage, setIsBaseImage] = useState(false);
  const [existingTnc, setExistingTnc] = useState([]);
  const [defaultTnc, setDefaultTnc] = useState([]);
  const [dataApihandler, setDataApihandler] = useState("");
  const [description, setDescription] = useState("");
  const [errorLabelDesc, setErrorLabelDesc] = useState("");
  const [errorLabeltnc, setErrorLabeltnc] = useState("");
  const [errorLabelname, setErrorLabelname] = useState("");
  const [errorLabelcode, setErrorLabelcode] = useState("");
  const [errorLabelQuantity, setErrorLabelQuantity] = useState("");
  const [errorLabelstart, setErrorLabelstart] = useState("");
  const [errorLabelAvailableDate, setErrorLabelAvailableDate] = useState("");
  const [errorLabelend, setErrorLabelend] = useState("");
  const [errorLabelapi, setErrorLabelapi] = useState("");
  const [edit, setEdit] = useState(f);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [availableDate, setAvailableDate] = useState(null);
  const [plainText, setPlainText] = useState("");
  const [imageType, setImageType] = useState("");
  const [loading, setLoading] = useState(false);
  const [publishedFlag, setPublishedFlag] = useState(false);
  const [productModalShow, setProductModalShow] = useState(false);
  const [onChangeErrorFlag, setOnChangeErrorFlag] = useState({
    CouponExpiry: true,
    CouponExpiryError: "",
  });
  const [downloadFlag, setDownloadFlag] = useState(false);
  //image crop
  const uploadedImage = useRef("");
  const imageUploader = useRef("");

  const [show, setShow] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(defaultupload);
  const [uploadImgurl, setuploadImgurl] = useState("");

  // upload-banner-img
  const [prevImg, setPrevimg] = useState("");
  const [cropImgBanner, setcropImgBanner] = useState("");
  const [bannerImageFlag, setbannerImageFlag] = useState(false);
  const [ImagePath, setImagePath] = useState("");

  const [showFb, setShowFb] = useState(false);
  const [prevImgFb, setPrevimgFb] = useState("");
  const [cropImgBannerFb, setcropImgBannerFb] = useState("");
  const [bannerImageFlagFb, setbannerImageFlagFb] = useState(false);
  const [ImagePathFb, setImagePathFb] = useState("");
  const [isbaseImageFb, setIsBaseImageFb] = useState(false);

  const allTnc = [...new Set([...existingTnc, ...defaultTnc])];

  const [couponStatus, setCouponStatus] = useState("published");

  const uid = parseInt(userId());
  const handleModelChange = (model) => {
    setDescription(model);
  };

  const handleStart = (e) => {
    setStartDate(e);
  };

  const handleAvailableDate = (e) => {
    setAvailableDate(e);
  };

  const handleEnd = (e) => {
    const EndDate = e;
    setEndDate(EndDate);
  };

  const handleChangetnc = (event) => {
    event.preventDefault();
    setInputtnc(event.target.value);
  };

  const handleCheck = (item) => {
    if (checkedItems.includes(item)) {
      setCheckedItems(
        checkedItems.filter((checkedItem) => checkedItem !== item),
      );
    } else {
      setCheckedItems([...checkedItems, item]);
    }
  };

  const handleAdd = (event) => {
    event.preventDefault();
    let temp = inputtnc;
    if (inputtnc != undefined) {
      setAddtnc((addtnc) => [...addtnc, temp]);
      setErrorLabeltnc("");
    } else {
      setErrorLabeltnc("Please enter a valid t&c");
    }
  };

  const handleTncApi = async () => {
    const data = {
      api_method: "get",
    };
    const tncList = await CreateCouponApi(data, () => {
      navigate("/");
    });
    if (tncList.status === 429) {
      setLoading(true);
      toast.error(tncList.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    let unique1 = tncList.tnc.filter((o) => apitnc.indexOf(o) === -1);
    let list = unique1.concat(addtnc);
    setDefaultTnc(list);
  };

  const Bu_data = getUser();

  const handleSubmit = (e, type, status = "published") => {
    e.preventDefault();
    setCouponStatus(status);

    let flag = false;
    const plainText = stripHTML(description);
    const currentCharCount = plainText.length;
    const hasInvalidTags = /<img|<figure/i.test(description);
    if (!description) {
      setErrorLabelDesc("Please provide some description!");
      flag = true;
    } else if (hasInvalidTags && currentCharCount > max_character_count) {
      setErrorLabelDesc(
        `Character limit exceeded! You can only enter up to ${max_character_count} characters, and images are not allowed.`,
      );
      flag = true;
    } else if (hasInvalidTags) {
      setErrorLabelDesc(ErrorMessage.ImageError);
      flag = true;
    } else if (currentCharCount > max_character_count) {
      setErrorLabelDesc(
        `Character limit exceeded! You can only enter up to ${max_character_count} characters.`,
      );
      flag = true;
    } else {
      setErrorLabelDesc("");
    }

    if (dat.coupon_name == "") {
      setErrorLabelname("Please enter coupon name!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelname("");
    }

    const alphanumericRegex = /^[a-zA-Z0-9]+$/; 

    if (dat.coupon_code === "") {
      setErrorLabelcode("Please enter coupon code!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (!alphanumericRegex.test(dat.coupon_code)) {
      setErrorLabelcode("Please enter alphanumeric characters only!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelcode("");
    }

    const quantityVal = dat.quantity;
    if (
      quantityVal === undefined ||
      quantityVal === null ||
      quantityVal === ""
    ) {
      setErrorLabelQuantity("Please enter total quantity!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (Number(quantityVal) <= 0 || isNaN(Number(quantityVal))) {
      setErrorLabelQuantity("Please enter a valid quantity greater than 0!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelQuantity("");
    }

    if (!startDate) {
      setErrorLabelstart("Please enter start date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelstart("");
    }

    if (!endDate) {
      setErrorLabelend("Please enter expiration date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelend("");
    }

    if (!availableDate) {
      setErrorLabelAvailableDate("Please enter available until date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelAvailableDate("");
    }

    if (checkedItems.length === 0) {
      setErrorLabeltnc("Please select at least one terms & condition!");
      flag = true;
    } else {
      setErrorLabeltnc("");
    }

    var imgPath;
    if (!isbaseImage) {
      imgPath = cropImgBanner.split("/").slice(3).join("/");
    }

    var imgPathFb;
    if (!isbaseImageFb) {
      imgPathFb = cropImgBannerFb.split("/").slice(3).join("/");
    }

    if (flag === false) {
      const dataApi = {
        api_method: "post",
        coupon_name: dat.coupon_name,
        business_id: parseInt(uid),
        category_id: Bu_data.category_id,
        coupon_code: dat.coupon_code,
        expiry_start_date: format(startDate, "yyyy-MM-dd"),
        coupon_avail_until_date: format(availableDate, "yyyy-MM-dd"),
        expiry_end_date: format(endDate, "yyyy-MM-dd"),
        description: description,
        city_id: Bu_data.city_id,
        coupon_img_change: edit === true && bannerImageFlag == true ? 1 : 0,
        is_image_changed: isbaseImage,
        image_path: {
          data: isbaseImage ? cropImgBanner : imgPath,
          file_type: "png",
        },
        is_social_image: isbaseImageFb,
        coupon_social_image_path: {
          data: isbaseImageFb ? cropImgBannerFb : imgPathFb,
          file_type: "png",
        },
        tnc: checkedItems,
        total_quantity: Number(dat.quantity),
        coupon_status: status,
      };
      if (type === "preview") {
        setProductModalShow(true);
      } else if (type === "save") {
        setDataApihandler(dataApi);
        setModalShow(true);
      }
    }
  };

  const navigate = useNavigate();

  const CouponCheckApiHandler = async (data) => {
    const CouponExpiryCheckRes = await CouponCheckApi(data, () => {
      navigate("/");
    });

    if (CouponExpiryCheckRes === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      if (CouponExpiryCheckRes.success === true) {
        setErrorLabelend("");
        setOnChangeErrorFlag((ps) => {
          return { ...ps, CouponExpiry: true, CouponExpiryError: "" };
        });
      } else {
        setErrorLabelend(CouponExpiryCheckRes.message);
        setOnChangeErrorFlag((ps) => {
          return {
            ...ps,
            CouponExpiry: false,
            CouponExpiryError: CouponExpiryCheckRes.message,
          };
        });
      }
    }
  };

  const handleCreate = async () => {
    setLoading(true);
    setModalShow(false);
    const res = await CreateCouponApi(dataApihandler, () => {
      navigate("/");
    });
    if (res === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      setLoading(false);
    } else {
      if (res.success === true) {
        toast.success("Coupon created successfully", {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate("/my-account/manage-coupons");
        setEdit(f);
        setErrorLabelDesc("");
        setErrorLabelend("");
        setErrorLabelname("");
        setErrorLabelstart("");
        setErrorLabeltnc("");
        setErrorLabelcode("");
        setErrorLabelQuantity("");
        setLoading(false);
      } else {
        toast.error(res.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  const handleApi = async () => {
    const d = {
      business_id: uid,
      coupon_id: id,
      limit: 8,
      offset: 0,
    };
    setLoading(true);
    const response = await ManageCouponsApi(d, () => {
      navigate("/");
    });
    setLoading(false);
    if (response === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      navigate("*");
    } else {
      if (response.status === 429) {
        toast.error(response.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(true);
      } else if (response.success === true) {
        setDat({
          coupon_name: "",
          coupon_code: "",
          quantity: "",
        });
        setApiTnc(response.data[0].coupon_tnc);
        setcropImgBanner(response.data[0].coupon_image);
        setcropImgBannerFb(response.data[0].coupon_social_image);
        setDescription(response.data[0].coupon_description);
        let couponTnc = response.data[0].coupon_tnc;
        let actualDate = new Date(response.data[0].start_date);
        let actualDateend = new Date(response.data[0].end_date);
        let actualAvaliableDate = new Date(
          response.data[0].coupon_avail_until_date,
        );
        if (flagValue) {
          setStartDate(null);
          setAvailableDate(null);
          setEndDate(null);
          setPublishedFlag(false);
          setExistingTnc(couponTnc.slice(1, couponTnc.length));
        } else {
          setStartDate(actualDate);
          setAvailableDate(actualAvaliableDate);
          setEndDate(actualDateend);
          setPublishedFlag(response.data[0].published);
          setExistingTnc(couponTnc);
        }
        setDownloadFlag(response.data[0].downloaded);
        setImagePath(response.data[0].coupon_image);
        setPlainText(
          response.data[0].coupon_description ? (
            response.data[0].coupon_description
          ) : (
            <></>
          ),
        );
      } else {
        toast.error(ServerError, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        navigate("*");
      }
    }
    setData(response.data[0]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDat({
      ...dat,
      [name]: value,
    });
    if (name === "quantity" && value && Number(value) > 0) {
      setErrorLabelQuantity("");
    }
  };

  useEffect(() => {
    handleApi();
    setDescription(dat.coupon_description);
  }, []);

  useEffect(() => {
    handleApi();
  }, [flagValue, flag]);

  useEffect(() => {
    handleTncApi();
  }, [addtnc, flagValue]);

  const handleImageUpload = (e) => {
    e.preventDefault();
    const [file] = e.target.files;
    if (file) {
      const reader = new FileReader();
      const { current } = uploadedImage;
      current.file = file;
      reader.onload = (e) => {
        current.src = e.target.result;
        setuploadImgurl(current.src);
      };
      reader.readAsDataURL(file);
      setShow(true);
    }
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation,
      );
      setcropImgBanner(croppedImage);
      setIsBaseImage(true);
      let typeImg = croppedImage.split("/");
      let imageTypeSplit = typeImg[1].split(";");

      setImageType(imageTypeSplit[0]);
      setShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const showCroppedImageFb = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImgFb,
        croppedAreaPixels,
        rotation,
      );
      setIsBaseImageFb(true);
      setcropImgBannerFb(croppedImage);

      let typeImg = croppedImage.split("/");
      let imageTypeSplit = typeImg[1].split(";");

      setImageType(imageTypeSplit[0]);
      setShowFb(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const onClose = useCallback(() => {
    setCroppedImage(null);
  }, []);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleImageSelect = (e) => {
    setImageSrc(URL.createObjectURL(e.target.files[0]));
  };
  const uploadFiles = () => {
    document.getElementById("selectFile").click();
  };

  const inputRef = useRef();
  const triggerFileSelectPopup = () => inputRef.current.click();

  const inputRefFb = useRef();
  const triggerFileSelectPopupFb = () => inputRefFb.current.click();

  const handleSetCropperImg = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const img = new window.Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      (async () => {
        const resizedImage = await resizeImage(
          img,
          constant.max_img_width,
          constant.max_img_height,
        );
        setShow(true);
        setPrevimg(resizedImage);
      })();
    };
  };

  const handleSetCropperImgFb = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const img = new window.Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      (async () => {
        const resizedImage = await resizeImage(
          img,
          constant.max_img_width,
          constant.max_img_height,
        );
        setShowFb(true);
        setPrevimgFb(resizedImage);
      })();
    };
  };

  useEffect(() => {
    setCheckedItems(existingTnc);
  }, [existingTnc]);

  return (
    <>
      {loading === true ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/my-account/manage-coupons"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">
            {edit === false ? "View Coupon" : "Clone Coupon"}
          </p>
          <div className="acc-dashboard mt-4">
            <div className="Create-voucher_top-section">
              <Modal
                show={show}
                onHide={() => setShow(false)}
                style={{ marginTop: 0 }}
              >
                <Modal.Header></Modal.Header>
                <Modal.Body
                  style={{ width: "100%", height: 350, body: "none" }}
                >
                  <div>
                    <Cropper
                      image={prevImg}
                      crop={crop}
                      rotation={rotation}
                      zoom={zoom}
                      aspect={4 / 4}
                      cropShape="square"
                      showGrid={false}
                      onCropChange={setCrop}
                      onRotationChange={setRotation}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer className="cropperImage">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShow(false);
                      setbannerImageFlag(false);
                    }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      showCroppedImage();
                      setbannerImageFlag(true);
                    }}
                  >
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                show={showFb}
                onHide={() => setShowFb(false)}
                style={{ marginTop: 0 }}
              >
                <Modal.Header></Modal.Header>
                <Modal.Body
                  style={{ width: "100%", height: 350, body: "none" }}
                >
                  <div>
                    <Cropper
                      image={prevImgFb}
                      crop={crop}
                      rotation={rotation}
                      zoom={zoom}
                      aspect={1.91 / 1}
                      showGrid={false}
                      onCropChange={setCrop}
                      onRotationChange={setRotation}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer className="cropperImage">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setShowFb(false);
                      setbannerImageFlagFb(false);
                    }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      showCroppedImageFb();
                      setbannerImageFlagFb(true);
                    }}
                  >
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>
              <div className="input_fileds">
                <Form className="formmain mx-2 mt-2 signin-row profile-form pb-0">
                  <Row>
                    <Col md="12" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Coupon Name <span className="star-required">*</span>
                        </Form.Label>
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            placeholder="Coupon Name"
                            className="custom-formcontrol"
                            maxLength={200}
                            name="coupon_name"
                            onChange={handleChange}
                            disabled={
                              publishedFlag === false && edit === true
                                ? false
                                : true
                            }
                            value={
                              edit === true ? dat.coupon_name : data.coupon_name
                            }
                          />
                        </InputGroup>
                        <ErrorLabel ErrorDisplay={errorLabelname} />
                      </Form.Group>
                    </Col>
                    <div className="d-flex gap-30 mb-4 img_sec_product">
                      <div className="col-4 px-0 mb-2 product-upload-section">
                        <div className="hiddenFileInputContainter">
                          <p className="uploadtextmain">
                            Upload Coupon Image &nbsp;
                            <span className="star-required">*</span>
                            <br />
                            <span className="info_text">
                              (Recommended size 1000px x 1000px)
                            </span>
                          </p>

                          <div
                            className="upload_main_banner"
                            onClick={
                              publishedFlag === false && edit === true
                                ? triggerFileSelectPopup
                                : ""
                            }
                          >
                            <input
                              type="file"
                              accept="image/*"
                              ref={inputRef}
                              style={{ display: "none" }}
                              onChange={handleSetCropperImg}
                              onClick={(e) => (e.target.value = null)}
                            />
                            <div>
                              {cropImgBanner == "" ? (
                                <>
                                  <div className="upload_banner_empty">
                                    <img
                                      loading="lazy"
                                      src={defaultupload}
                                      height="300"
                                      width="300"
                                      alt="upload"
                                    />
                                  </div>
                                </>
                              ) : (
                                <img
                                  loading="lazy"
                                  src={cropImgBanner}
                                  className="BannerImgStore"
                                  height={300}
                                  width={300}
                                  style={{
                                    cursor:
                                      publishedFlag === false && edit === true
                                        ? "pointer"
                                        : "not-allowed",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-8 px-0">
                        <div className="hiddenFileInputContainter">
                          <p className="uploadtextmain">
                            Upload Social Share Image &nbsp;
                            <span style={{ fontSize: 13, fontStyle: "italic" }}>
                              &#40;Optional&#41;
                            </span>
                            &nbsp;&nbsp;
                            <span className="info_text">
                              (Recommended size 1200px x 630px)
                            </span>
                            <br />
                            <div style={{ paddingRight: 10 }}>
                              <p className="span-italic-grey1">
                                &#40;This image is ideal for social share, if
                                you are unable to provide this size we will use
                                the square image modified to fit the standard
                                image recommendation.&#41;
                              </p>
                            </div>
                          </p>

                          <div
                            className="upload_main_banner"
                            onClick={
                              publishedFlag === false && edit === true
                                ? triggerFileSelectPopupFb
                                : ""
                            }
                          >
                            <input
                              type="file"
                              accept="image/*"
                              ref={inputRefFb}
                              style={{ display: "none" }}
                              onChange={handleSetCropperImgFb}
                              onClick={(e) => (e.target.value = null)}
                            />
                            <div>
                              {cropImgBannerFb == "" ? (
                                <>
                                  <div className="upload_banner_empty_fb">
                                    <img
                                      loading="lazy"
                                      src={defaultupload_fb}
                                      alt="upload"
                                    />
                                  </div>
                                </>
                              ) : (
                                <img
                                  loading="lazy"
                                  src={cropImgBannerFb}
                                  className="BannerImgStore"
                                  style={{
                                    cursor:
                                      publishedFlag === false && edit === true
                                        ? "pointer"
                                        : "not-allowed",
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Col md="6" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom info-sec">
                          Coupon Code <span className="star-required">*</span>{" "}
                          <p className="info-text-space-f13">
                            &#40;Please enter alphanumeric characters only.&#41;
                          </p>
                        </Form.Label>
                        <InputGroup className="edit-border">
                          <Form.Control
                            type="text"
                            placeholder="Coupon Code"
                            className="custom-formcontrol"
                            maxLength={12}
                            name="coupon_code"
                            onChange={handleChange}
                            disabled={
                              publishedFlag === false && edit === true
                                ? false
                                : true
                            }
                            value={
                              edit === true ? dat.coupon_code : data.coupon_code
                            }
                          />
                        </InputGroup>
                        <ErrorLabel ErrorDisplay={errorLabelcode} />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="form-label-custom">
                          Total Quantity{" "}
                          <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          name="quantity"
                          value={edit === true ? dat.quantity : data.quantity}
                          min="1"
                          onChange={handleChange}
                          placeholder="Enter Total Quantity"
                          className="custom-formcontrol"
                          disabled={
                            publishedFlag === false && edit === true
                              ? false
                              : true
                          }
                        />
                        <div className="coupon-error-msg">
                          <ErrorLabel ErrorDisplay={errorLabelQuantity} />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="VoucherAmountDollar">
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <p>
                            Coupon Publish Start Date
                            <span className="star-required">*</span>
                          </p>
                        </Form.Label>
                        <div>
                          <InputGroup className="edit-border">
                            <DatePicker
                              selected={startDate}
                              className="custom-formcontrol"
                              onChange={handleStart}
                              placeholderText="Publish Start Date"
                              minDate={new Date()}
                              maxDate={
                                availableDate !== null
                                  ? availableDate
                                  : endDate !== null
                                    ? endDate
                                    : ""
                              }
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : true
                              }
                              defaultValue={dat.start_date}
                            />
                            <Image
                              loading="lazy"
                              src={Datepickericon}
                              className="date-picker-icon"
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabelstart} />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <p>
                            Coupon Available Until Date
                            <span className="star-required">*</span>
                          </p>
                        </Form.Label>
                        <div>
                          <InputGroup className="edit-border">
                            <DatePicker
                              selected={availableDate}
                              className="custom-formcontrol"
                              onChange={handleAvailableDate}
                              placeholderText="Available Until Date"
                              minDate={
                                startDate !== null ? startDate : new Date()
                              }
                              maxDate={endDate !== null ? endDate : null}
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : publishedFlag === true && edit === true
                                    ? false
                                    : true
                              }
                            />
                            <Image
                              loading="lazy"
                              src={Datepickericon}
                              className="date-picker-icon"
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabelAvailableDate} />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md="4" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <p>
                            Coupon Expiration Date
                            <span className="star-required">*</span>
                          </p>
                        </Form.Label>
                        <div>
                          <InputGroup className="edit-border">
                            <DatePicker
                              selected={endDate}
                              className="custom-formcontrol"
                              onChange={handleEnd}
                              placeholderText="Expiration Date"
                              minDate={
                                availableDate !== null &&
                                availableDate > startDate
                                  ? availableDate
                                  : startDate !== null
                                    ? startDate
                                    : new Date()
                              }
                              disabled={
                                publishedFlag === false && edit === true
                                  ? false
                                  : publishedFlag === true && edit === true
                                    ? false
                                    : true
                              }
                            />
                            <Image
                              loading="lazy"
                              src={Datepickericon}
                              className="date-picker-icon"
                            />
                          </InputGroup>
                          <ErrorLabel ErrorDisplay={errorLabelend} />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
            <Row
              className={`mx-2 mt-2 view-coup ${
                flagValue === true ? "true" : ""
              }`}
            >
              <Col md="12" className="pb-0 px-2">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  {(publishedFlag === true && edit === true) ||
                  edit === false ? (
                    <>
                      <Form.Label className="form-label-custom info-sec">
                        Description
                        <span className="star-required">*</span>
                      </Form.Label>
                      <FroalaEditorView model={plainText} />
                    </>
                  ) : publishedFlag === false && edit === true ? (
                    <>
                      <Form.Label className="form-label-custom info-sec">
                        Coupon Description{" "}
                        <span className="star-required">*</span>{" "}
                        <p className="info-text-space-f13">
                          &#40;To start from a new line, please press Shift +
                          Enter.&#41;
                        </p>
                      </Form.Label>
                      <FroalaTextEditor
                        description={description}
                        setDescription={setDescription}
                        max_character_count={max_character_count}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  <ErrorLabel ErrorDisplay={errorLabelDesc} />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mx-2 view-coup">
              <Col md="12" className="pb-0 px-2">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Terms & Conditions <span className="star-required">*</span>
                    {edit === true && (
                      <span className="span-italic">
                        You can select terms & conditions listed below or you
                        can add more.
                      </span>
                    )}
                  </Form.Label>
                  <InputGroup className="edit-border">
                    {(publishedFlag === true && edit === true) ||
                    edit === false ? (
                      <Form.Group
                        className="mb-3 ack term-sec"
                        controlId="formBasicCheckbox"
                      >
                        {existingTnc
                          ? existingTnc.map((item) => {
                              return (
                                <ul>
                                  <li>{item}</li>
                                </ul>
                              );
                            })
                          : " "}
                        <ErrorLabel ErrorDisplay={errorLabeltnc} />
                      </Form.Group>
                    ) : (
                      publishedFlag === false &&
                      edit === true && (
                        <InputGroup className="edit-border">
                          <Form.Group
                            className="mb-3 ack term-sec"
                            controlId="formBasicCheckbox"
                          >
                            {allTnc &&
                              allTnc.length > 0 &&
                              allTnc.map((item, i) => {
                                return (
                                  <label
                                    for={item}
                                    value={item}
                                    className="form-check-label"
                                    style={{ display: "flex", gap: 10 }}
                                  >
                                    <input
                                      type="checkbox"
                                      id={item}
                                      className="form-check-input form-check ack"
                                      style={{ border: "1px solid #e66100" }}
                                      checked={checkedItems.includes(item)}
                                      onChange={() => handleCheck(item)}
                                    />
                                    {item}
                                  </label>
                                );
                              })}

                            <InputGroup className="search-bar add-bar tcAdd">
                              <Form.Control
                                placeholder="Add More"
                                onChange={handleChangetnc}
                                value={inputtnc}
                                className="addmor"
                                maxLength={200}
                              />
                              <Button
                                variant="outline-secondary"
                                onClick={handleAdd}
                              >
                                + Add
                              </Button>
                            </InputGroup>
                            <ErrorLabel ErrorDisplay={errorLabeltnc} />
                          </Form.Group>
                        </InputGroup>
                      )
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              {edit === true && (
                <>
                  <div className="text-center gap-4 small-btns d-flex mt-4">
                    <button
                      className="green-btn mt-3 update-Btn"
                      onClick={(e) => handleSubmit(e, "preview")}
                    >
                      Preview
                    </button>
                    <Button
                      className="discard_btn"
                      variant="primary"
                      onClick={(e) => handleSubmit(e, "save", "draft")}
                    >
                      Save As draft
                    </Button>
                  </div>

                  <div className="d-flex gap-4 justify-content-center mt-4 formmain">
                    <Button
                      className="discard_btn"
                      variant="secondary"
                      onClick={() => {
                        navigate("/my-account/manage-coupons");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="green-btn mt-3 update-Btn"
                      variant="primary"
                      onClick={(e) => handleSubmit(e, "save", "published")}
                    >
                      Save
                    </Button>
                  </div>
                </>
              )}
            </Row>
          </div>
        </div>
      </div>
      <Modals
        className="Modal_Popup"
        show={modalShow}
        onHide={() => setModalShow(false)}
        images={SuccessImage}
        description={
          couponStatus === "draft"
            ? "Your coupon has been saved as a draft. You can edit and publish it at any time."
            : "Your coupon is almost ready! Click 'Yes' to finish creating, but remember, once created you cannot delete the coupon but can always disable it whenever you want. This will not affect the customers who might have already downloaded the coupon, they can still redeem it."
        }
        firstbutton="No"
        secondbutton="Yes"
        saveButtonfuc={handleCreate}
        Apidata={dataApihandler}
      />
      <ProductModal
        className="Modal_Popup"
        show={productModalShow}
        onHide={() => setProductModalShow(false)}
        flag="Coupon"
        product_name={dat.coupon_name}
        product_image={cropImgBanner}
        availableDat={availableDate}
        endDat={endDate}
        description={description}
        tnc={checkedItems}
      />
      <PrivacyTermsConditions />
    </>
  );
};

export default CloneCoupon;
